 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsAccountClientAddress',
	};

	$(document).ready(function documentReady()
	{
		// Adzuki.Form.registerForm(form);
		Adzuki.onload('/MyTrips/editMyAccountClientAddress/', init);

	});

	function init() {

		Adzuki.Form.registerForm(form);

		// if the user modifies one of the address fields, we are going to set the hidden satori_updated field to 0
		// we are doing this because it's possible for the user to take the initial Satori suggestion, which would set satori_updated to 1, then
		// the system can recognize that the address is a dupe or Satori could catch an Address 2 issue and the submission would not go thru all the way
		// In that case, the user could modify the address again in the form, which could result in a bad address they force thru all together or a
		// pristine address that Satori does not modify at all. Either scenario, we should not flag the household as satori_updated
		$(".address-fields").on("change", "input, select", function changed(e)
		{
			var $self           = $(this),
			    $address_fields = $self.closest('.address-fields'),
			    $satori_updated = $address_fields.find('.satori-updated').find('input[type=hidden]');

			$satori_updated.val(0);
		});
	}

	form.confirmation = function confirmation(response)
	{
		// if (response.data.response_code === "related_household") {
		// 	householdPropagateConfirm(form.name);

		// // this means a confirm dialog needs to be thrown due to a duplicate household address
		if (response.data.response_code === "duplicate") {
			duplicateConfirm(form.name);

		// this means a confirm dialog needs to be thrown due to a connection error with Satori
		} else if (response.data.response_code === "connection_error") {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// this is a Satori rejected address with no suggested alternative. User still should be able to force it through
		} else if (response.data.response_code > 100) {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// a Satori alternate address suggested.  Need for user to confirm what to do with it
		} else {
			Adzuki.AddressVerification.confirmWithSuggestion(response, form.name);
		}
	};

	function duplicateConfirm(form_name)
	{
		var $jForm;

		Adzuki.CustomConfirm({
			body   : 'This address already exists for this client in your database. We do not recommend you create duplicate records. Do you wish to proceed with saving this address anyway?',
			confirm: function yes() {
				$jForm = $('form[name="' + form_name + '"]');

				// set hidden input indicating that the user wants to ignore the dupe address, so we do not throw a confirm again
				$jForm.find('.ignore_dupe').val(1);
				$jForm.submit();
			}
		});
	}

}(jQuery, window.Adzuki || {}));
